import { ActionTypes } from "../constantes/ActionTypes";
import axios from "../../../../common/axios";
import { shipmentInfoSuccess } from "../actions/ShipmentByUserAction";
import _ from "lodash";
import { soldeStart } from "./SoldeAction";
import { extractUrlParams } from "../../../../common/utils/Utils";

export const shipmentRefreshStart = (action) => {
  return (dispatch) => {
    dispatch(action);
    axios
      .get(
        `/refreshShipment?id=${action.payload}`
      )
      .then((response) => {
        let dataBeforeRefresh = action.data;
        let refreshedRow = response.data.list;
        let dataAfterRefresh = dataBeforeRefresh.list.map(
          (obj) =>
            refreshedRow.find((o) => {
              return o.id === obj.id;
            }) || obj
        );
        let objectParam = { ...action.data, ...{ list: dataAfterRefresh } };
        dispatch(shipmentRefreshSuccess(objectParam));
        dispatch(shipmentInfoSuccess(objectParam));
        dispatch(
          soldeStart({
            type: ActionTypes.ACTION_SOLDE_START,
            payload: extractUrlParams(window.location.href),
          })
        );
      })
      .catch((error) => {
        dispatch(shipmentRefreshFailed(error.response?.data));
      });
  };
};

export const shipmentRefreshSuccess = (shipmentInfo) => {
  console.log(shipmentInfo);
  return {
    type: ActionTypes.ACTION_SHIPMENT_REFRESH_SUCCESS,
    payload: shipmentInfo,
  };
};

export const shipmentRefreshFailed = (error) => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_REFRESH_FAILED,
    payload: error,
  };
};
